module.exports = __webpack_public_path__ + "static/media/feelingProud.c5502442.svg";